/* =========================================================================
   MARKETING Hero — Content Studio: shared types & constants.
   Two capabilities: (1) generate a content plan/calendar, (2) audit existing
   content for gaps.
   ========================================================================= */

export const CONTENT_TYPES: { id: string; label: string; stage: string }[] = [
  { id: "awareness", label: "Awareness — สร้างการรับรู้", stage: "TOFU" },
  { id: "education", label: "Education — ให้ความรู้", stage: "TOFU" },
  { id: "problem", label: "Problem — ปลุกปัญหา", stage: "TOFU" },
  { id: "engagement", label: "Engagement — สร้างการมีส่วนร่วม", stage: "TOFU" },
  { id: "trust", label: "Trust — สร้างความเชื่อใจ", stage: "MOFU" },
  { id: "authority", label: "Authority — สร้างความน่าเชื่อถือ", stage: "MOFU" },
  { id: "review", label: "Review — รีวิวลูกค้า", stage: "MOFU" },
  { id: "case_study", label: "Case Study — เคสตัวอย่าง", stage: "MOFU" },
  { id: "objection", label: "Objection — แก้ข้อโต้แย้ง", stage: "MOFU" },
  { id: "sales", label: "Sales — ขาย", stage: "BOFU" },
  { id: "conversion", label: "Conversion — เร่งปิดการขาย", stage: "BOFU" },
  { id: "retarget", label: "Retarget — รีทาร์เก็ต", stage: "BOFU" },
];
export const contentTypeLabel = (id: string) => CONTENT_TYPES.find((t) => t.id === id)?.label ?? id;
export const contentTypeStage = (id: string) => CONTENT_TYPES.find((t) => t.id === id)?.stage ?? "TOFU";

export const PLATFORMS = ["Facebook", "TikTok", "Instagram", "YouTube", "LINE"];

export interface ContentPlanInputs {
  rangeDays?: number; // 7 | 14 | 30
  platforms?: string[];
  product?: string; pain?: string; desire?: string; persona?: string; objective?: string; name?: string;
}

export interface ContentItem {
  day: number;
  type: string;
  platform: string;
  funnelStage: string;
  topic: string;
  hook: string;
  angle: string;
  caption: string;
  cta: string;
  visualConcept: string;
  videoConcept: string;
  targetPersona: string;
  objective: string;
}

export interface ContentPlanOutput {
  pillars: { name: string; description: string; ratio: string }[];
  items: ContentItem[];
  disclaimer?: string;
}

export interface ContentAuditOutput {
  contentMix: { type: string; count: number }[];
  repeatedTopics: string[];
  repeatedHooks: string[];
  gaps: { area: string; severity: "high" | "medium" | "low"; note: string }[];
  recommendations: { priority: number; action: string; why: string }[];
  disclaimer?: string;
}

export const CONTENT_PLAN_SCHEMA_HINT = {
  pillars: [{ name: "string", description: "string", ratio: "string เช่น 30%" }],
  items: [{ day: 1, type: "awareness|education|problem|trust|authority|review|case_study|engagement|sales|objection|retarget|conversion", platform: "Facebook|TikTok|Instagram|YouTube|LINE", funnelStage: "TOFU|MOFU|BOFU", topic: "string", hook: "string", angle: "string", caption: "string — แคปชั่นจริง", cta: "string", visualConcept: "string", videoConcept: "string", targetPersona: "string", objective: "string" }],
};

export const CONTENT_AUDIT_SCHEMA_HINT = {
  contentMix: [{ type: "string", count: 0 }],
  repeatedTopics: ["string"],
  repeatedHooks: ["string"],
  gaps: [{ area: "string เช่น Missing BOFU / Review Gap", severity: "high|medium|low", note: "string" }],
  recommendations: [{ priority: 1, action: "string", why: "string" }],
};
